import _createClass from "/Users/yashshelatkar/Documents/yash-shelatkar-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/Users/yashshelatkar/Documents/yash-shelatkar-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
export var EmailJSResponseStatus = /*#__PURE__*/_createClass(function EmailJSResponseStatus(httpResponse) {
  _classCallCheck(this, EmailJSResponseStatus);

  this.status = httpResponse.status;
  this.text = httpResponse.responseText;
});